<template>
  <div class="container">
    <b-row class="justify-content-center">
      <b-col md="8">
        <b-card-group>
          <b-card no-body class="p-4">
            <b-card-body>
              <b-form>
                <h1>Anmeldung</h1>
                <p class="text-muted">Anmeldung zu Ihrem Account</p>
                <b-input-group
                  class="mb-3"
                  :class="{ invalid: $v.customerId.$error }"
                >
                  <b-input-group-prepend
                    ><b-input-group-text
                      ><i class="cil-tags"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    :class="{ invalid: $v.password.$error }"
                    @click="authReset"
                    @keypress="isEnter($event)"
                    placeholder="Kundennummer"
                    autocomplete=""
                    v-model="customerId"
                    @input="$v.customerId.$touch()"
                  />
                </b-input-group>
                <p class="error-text" v-if="$v.customerId.$error">
                  Pflichtfeld: Bitte ausfüllen!
                </p>
                <b-input-group
                  class="mb-3"
                  :class="{ invalid: $v.username.$error }"
                >
                  <b-input-group-prepend
                    ><b-input-group-text
                      ><i class="icon-user"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <b-form-input
                    type="text"
                    class="form-control"
                    :class="{ invalid: $v.password.$error }"
                    placeholder="Benutzername"
                    autocomplete="username email"
                    v-model="username"
                    @click="authReset"
                    @keypress="isEnter($event)"
                    @input="$v.username.$touch()"
                  />
                </b-input-group>
                <p class="error-text" v-if="$v.username.$error">
                  Pflichtfeld: Bitte ausfüllen!
                </p>
                <b-input-group
                  class="mb-4"
                  :class="{ invalid: $v.password.$error }"
                >
                  <b-input-group-prepend
                    ><b-input-group-text
                      ><i class="icon-lock"></i></b-input-group-text
                  ></b-input-group-prepend>
                  <b-form-input
                    type="password"
                    class="form-control"
                    :class="{ invalid: $v.password.$error }"
                    placeholder="Passwort"
                    v-model="password"
                    @click="authReset"
                    @keypress="isEnter($event)"
                    @input="$v.password.$touch()"
                  />
                </b-input-group>
                <p class="error-text" v-if="$v.password.$error">
                  Pflichtfeld: Bitte ausfüllen!
                </p>
                <b-row>
                  <b-col cols="4">
                    <b-button
                      variant="primary"
                      class="px-4"
                      :class="{
                        disabled:
                          $v.customerId.$error ||
                          $v.username.$error ||
                          $v.password.$error,
                      }"
                      @click="loginUser"
                      >Anmelden</b-button
                    >
                  </b-col>
                  <b-col cols="6"
                    ><span v-show="loginError" style="color: red"
                      >Login fehlgeschlagen!</span
                    ></b-col
                  >
                </b-row>
              </b-form>
            </b-card-body>
          </b-card>
        </b-card-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { mapActions, mapGetters } from "vuex";

// VUE izitoast
import Vue from "vue";
import VueIziToast from "vue-izitoast";
import "izitoast/dist/css/iziToast.min.css";
Vue.use(VueIziToast);

import NotificationMixin from "../mixins/notificationmixin";

export default {
  name: "Login",
  mixins: [NotificationMixin],
  data() {
    return {
      customerId: "",
      username: "",
      password: "",
    };
  },
  validations: {
    customerId: {
      required,
    },
    username: {
      required,
    },
    password: {
      required,
    },
  },
  methods: {
    ...mapActions(["authRequest", "login", "authReset", "checkToken"]),
    submit() {
      this.$router.push("/dashboard");
    },
    loginUser: async function () {
      const { customerId, username, password } = this;
      this.login({ customerId, username, password });
    },
    isEnter(event) {
      if (event.key === "Enter") {
        const { customerId, username, password } = this;
        this.login({ customerId, username, password });
      }
    },
    async checkForToken() {      
      let search = window.location.search;
      // get rid of url get params
      window.history.replaceState({}, document.title, "/");

      if (search.includes("pid") && search.includes("token")) {
        console.log("pid and token valid")
        let pid = search.substring(
          search.indexOf("pid") + 4,
          search.indexOf("&")
        );
        let token = search.substring(search.indexOf("token") + 6);

        let data = await this.checkToken({ pid, token });
        if (data) {
          this.login(data);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["authStatus"]),
    loginError: function () {
      return this.authStatus === "error";
    },
  },
  mounted: function () {
    this.checkForToken();
    if (this.$route.params.consecutiveVisit) {
      this.notify(
        1,
        ``,
        `Sie wurden abgemeldet! Bitte melden Sie sich erneut an.`,
        this.$toast
      );
    }
  },
};
</script>

<style scoped>
.input-group.invalid {
  border: 1px solid red;
  border-radius: 5px;
}
.invalid input {
  background-color: rgb(252, 198, 198);
}
.error-text {
  color: red;
}
.card-group {
  margin-top: 25vh;
}
</style>
